









































































































































































































import _ from "lodash";
import rest from "@/rest";
import { Component, Vue, Watch, Prop, PropSync } from "vue-property-decorator";
import { Action, namespace } from "vuex-class";
import { List } from "linq-collections";
import { vuex } from "@/store";
import router from "@/router";
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
// component
import NumberInput from "@/components/Shared/NumberInput.vue"
// interfaces
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { ExTypeItem, exTypeItems } from "@/interfaces/Types";
import { ExType } from "@/interfaces/ExType";
import { ExBundleVM } from "@/interfaces/ExBundleVM";

//const auth = namespace("auth");
const globals = namespace("globals");

@Component({
  components: {
    NumberInput
  }
})
export default class EditModuleDlg extends Vue {
  @PropSync("showDialog") syncedShowDialog!: boolean;

  @globals.Getter selectedBundle!: ExBundleVM;
  @globals.Getter selectedExercise!: ExerciseVM;

  busyOnSave = false;
  loading = false;
  editExercise: ExerciseVM | null = null;
  formValid = false;
  // exTypeItems = exTypeItems;

  // @auth.Getter isAdmin: any;
  // @auth.Getter isOrgAdmin: any;
  // @auth.Getter isGroupAdmin: any;

  $refs!: {
    formElement: HTMLFormElement;
  };

  mounted() {
  }

  @Watch("syncedShowDialog")
  async onShowDialogChanged(val: boolean) {
    if (this.syncedShowDialog) {
      // On dialog open
      await this.updateView();
      this.editExercise = _.cloneDeep(this.selectedExercise);

      // Ensure nameTranslations exists and has entries for all bundle translation languages
      if (!this.editExercise!.nameTranslations) {
        this.editExercise!.nameTranslations = {} as any;
      }
      if (this.selectedBundle && this.selectedBundle.translationLanguageCodes) {
        const nt = this.editExercise!.nameTranslations as Record<string,string>;
        this.selectedBundle.translationLanguageCodes.forEach((langCode: string) => {
          if (!nt[langCode]) {
            nt[langCode] = '';
          }
        });
      }

      // Scrom settings animation
      this.loading = true
      await this.$globalHelper.delay(100);
      this.loading = false;

      // Disable body scroll on iOS
      this.$nextTick(async () => {
        await this.$globalHelper.delay(10);
        const modal = document.querySelector('.modal');
        disableBodyScroll(modal);
      });
    } else {
      // Dialog closing
      clearAllBodyScrollLocks();
    }
  }

  beforeDestroy() {
    clearAllBodyScrollLocks();
  }

  async updateView() {
  }

  get moduleIcon(): string {
    return exTypeItems.find(i => ExType[i.value] == this.selectedExercise.type)?.icon || "mdi-help-circle-outline";
  }

  get modulLabel(): string {
    return exTypeItems.find(i => ExType[i.value] == this.selectedExercise.type)?.label || "Modul";
  }

  get languageOptions() {
    return (this as any).$globalHelper.euLanguageOptions;
  }

  getLanguageText(code: string): string {
    const lang = this.languageOptions.find((l: any) => l.value === code);
    return lang ? lang.text : code;
  }

  getFlagUrlForLanguage(code: string): string {
    const lang = this.languageOptions.find((l: any) => l.value === code);
    if (lang?.countryCode) {
      return (this as any).$globalHelper.getFlagUrl(lang.countryCode);
    }
    return '';
  }

  onClose() {
    clearAllBodyScrollLocks();
    this.syncedShowDialog = false;
  }

  async onSave() {
    if (!(await this.$refs.formElement.validate()))
      return;

    this.busyOnSave = true;

    await rest.url("contentManager/addOrUpdateExercise")
      .post(this.editExercise)
      .then((response) => {
        if (!response) return;
        this.$emit("saved:editModuleDlg");
      })
      .finally(() => {
        this.busyOnSave = false;
        this.syncedShowDialog = false;
      });

    // this.$refs.formElement.reset();
  }

  nameRules = [
    (v: string) => !!v || "Eingabe erforderlich",
    (v: string) => (v && v.length >= 2) || "Name zu kurz",
    (v: string) => (v && v.length <= 80) || "Name zu lang"
  ];

  commentRules = [
    (v: string) => (!v || v && v.length <= 120) || "Hinweis zu lang"
  ];

}
